import Beginning from './Beginning';
export default Beginning;